import React from "react";
import { FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faSignOutAlt, faUser  } from "@fortawesome/free-solid-svg-icons";
import {
  Nav,
  Image,
  Navbar,
  Dropdown,
  Container,
} from "@themesberg/react-bootstrap";

import Profile3 from "../assets/img/team/inceptionAdmin.jpeg";
import { useHistory } from "react-router-dom";
import { Routes } from "../routes";
import { usePermissions } from "../context/PermissionContext";
import { tracker } from "../service/mixpanel";
import { useAuth } from "../context/AuthContext";

export default (props) => {
  const history = useHistory();
  const { name } = useAuth();
  const { resetPermissions } = usePermissions();
  const handleLogout = () => {
    tracker.logout.onClick();
    resetPermissions();
    localStorage.removeItem("token");
    history.push(Routes.Signin.path);
  };

  const redirectToProfile = () => {
    history.push(Routes.Profile.path)
  }

  return (
    <Navbar variant="dark" expanded className="ps-0 pe-2 pb-0">
      <Container fluid className="px-0">
        <div className="d-flex justify-content-between w-100">
          <div className="d-flex align-items-center"></div>
          <Nav className="align-items-center">
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle as={Nav.Link} className="pt-1 px-0">
                <div className="media d-flex align-items-center">
                  <Image
                    src={Profile3}
                    className="user-avatar md-avatar rounded-circle"
                  />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{name}</span>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="user-dropdown dropdown-menu-right mt-2 ">
                <Dropdown.Item className="fw-bold" onClick={redirectToProfile}>
                  <FontAwesomeIcon
                    icon={faUser}
                    className="me-2"
                  />{" "}
                  Profile
                </Dropdown.Item>
                <Dropdown.Item className="fw-bold" onClick={handleLogout}>
                  <FontAwesomeIcon
                    icon={faSignOutAlt}
                    className="text-danger me-2"
                  />{" "}
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </div>
      </Container>
    </Navbar>
  );
};
